/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FeaturedCommentContainer_settings = {
    readonly featuredBy: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ReactionButtonContainer_settings" | "UserTagsContainer_settings" | "MediaSectionContainer_settings" | "UsernameWithPopoverContainer_settings">;
    readonly " $refType": "FeaturedCommentContainer_settings";
};
export type FeaturedCommentContainer_settings$data = FeaturedCommentContainer_settings;
export type FeaturedCommentContainer_settings$key = {
    readonly " $data"?: FeaturedCommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featuredBy",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReactionButtonContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MediaSectionContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UsernameWithPopoverContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '8a791ca3fce7d8eb2254b7d89f1711db';
export default node;
